import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatMenuPanel } from '@angular/material/menu';

@Component({
  selector: 'app-item-card',
  templateUrl: './item-card.component.html',
  styleUrls: ['./item-card.component.scss']
})
export class ItemCardComponent {

  @Input() clickable = true;
  @Input() menu?: MatMenuPanel;

  @Output() openItemClicked = new EventEmitter<MouseEvent>();
}
